<template>
  <div class="main">
    <SideMenu />
    <Header title="Содержание и статистика" theme="white" />
    <div class="main-content" v-if="statsTree">
      <ul class="stats">
        <ProgressItem v-for="(item, key) in statsTree" :item="item" :key="key" :mobile="mobile" />
      </ul>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header/Header.vue";
import SideMenu from "../components/SideMenu/SideMenu.vue";
import ProgressItem from "../components/ProgressItem.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Stats",
  components: {
    Header,
    SideMenu,
    ProgressItem,
  },
  data: () => ({
      mobile: false
  }),
  methods: {
    ...mapActions({
      getStatsTree: "user/getStatsTree"
    })
  },
  computed: {
    ...mapGetters({
      statsTree: "user/statsTree"
    }),
  },
  created() {
    this.mobile = window.document.documentElement.clientWidth <= 960;

    this.getStatsTree()
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars.scss";

.main {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background: #fff;
  background-position: 100% 0;
}

.main-content {
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  margin: 100px 0 0;
  padding: 0 32px;
  overflow: auto;
}

.stats {
  display: flex;
  flex-flow: column;
  gap: 15px;
  margin: 0 0 40px;
  padding: 0 !important;
  list-style-type: none;
}

@media screen and (max-width: 960px) {
  .main-content {
    margin: 48px 0;
  }

  .stats {
    margin: 16px 0;
  }
}
</style>
